<div [style.min-height]="'100px'">
  <img
    crossorigin="anonymous"
    width="100"
    height="100"
    [ngSrc]="storeImage"
    [style.max-width]="maxWidth"
    alt="image de la boutique"
    class="mat-elevation-z10"
  />
</div>
